import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useUtility, useIsMobile, Stack, Text } from '@hub-la/design-system';
import { useGetBusiness } from '@hub-la/fe-get-user';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { withAccountVerification } from '../hoc/with-account-verification.js';

const AccountVerificationLink = withAccountVerification(Text);
const AccountVerificationBanner = () => {
  var _a;
  const [open, setOpen] = useState(false);
  const {
    palette
  } = useUtility();
  const {
    t
  } = useTranslation();
  const {
    data: account,
    isLoading
  } = useGetBusiness();
  const isMobile = useIsMobile();
  const location = useLocation();
  const hasAccount = (_a = account === null || account === void 0 ? void 0 : account.bankAccount) === null || _a === void 0 ? void 0 : _a.verificationStatus;
  const isAtProductsPage = location.pathname.includes('/dashboard') && location.hash.includes('products');
  const showBanner = isAtProductsPage && !hasAccount && !isLoading;
  useEffect(() => {
    if (showBanner) {
      setOpen(true);
    }
  }, [showBanner]);
  return open && !hasAccount ? jsxs(Stack, Object.assign({
    direction: "row",
    style: {
      backgroundColor: palette('surfaceAt1'),
      borderBottom: `1px solid ${palette('surfaceAt4')}`
    },
    px: 10,
    py: 4
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: ['column', 'row'],
      gap: 2,
      flex: 1,
      alignItems: ['start', 'center']
    }, {
      children: [!isMobile && jsx(InfoOutlinedIcon, {}), jsx(Text, {
        children: t('accountVerificationBanner.title')
      }), jsx(AccountVerificationLink, Object.assign({
        color: "primary",
        style: {
          textDecoration: 'underline',
          cursor: 'pointer'
        }
      }, {
        children: t('accountVerificationBanner.cta')
      }))]
    })), jsxs(Stack, Object.assign({
      direction: "row",
      onClick: () => setOpen(false),
      style: {
        cursor: 'pointer'
      },
      alignItems: "center"
    }, {
      children: [!isMobile && jsx(Text, Object.assign({
        variant: "body1"
      }, {
        children: t('accountVerificationBanner.close')
      })), jsx(CloseOutlinedIcon, {})]
    }))]
  })) :
  // eslint-disable-next-line react/jsx-no-useless-fragment
  jsx(Fragment, {});
};

export { AccountVerificationBanner };
